<template>
  <div ref="wrapper" style="width:100%;height:100%;">
    <slot></slot>
  </div>
</template>

<script>
import BScroll from "better-scroll";

export default {
  name: "BScroll",
  props: {
    scrollbar: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.scrollbar) {
      this.$nextTick(() => {
        this.scroll = new BScroll(this.$refs.wrapper, {
          scrollX: false,
          //click: true,
          //taps: true,
          bounce: true,
          momentumLimitDistance: 5,
          scrollY: true,
          scrollbar: {
            fade: false,
            interactive: false // 1.8.0 新增
          },
          mouseWheel: true
        });
        setTimeout(() => {
          this.scroll.scrollTo(0, this.$store.state.childModalOffsetY)
        }, 300);
      });
    } else {
      this.$nextTick(() => {
        this.scroll = new BScroll(this.$refs.wrapper, {
          scrollY: true,
          scrollX: false,
          mouseWheel: true,
          //click: true,
          //taps: true
        });
      });
    }
  }
};
</script>

<style scoped lang="less"></style>
